export interface MapIdentifyLocation {
  id: string
  name: string
  address: string
}

export const fetchMapIdentify = async (
  eastingX: number,
  northingY: number,
  lang = 'en'
): Promise<MapIdentifyLocation> => {
  const params = new URLSearchParams({
    x: String(eastingX),
    y: String(northingY),
    lang
  })
  const response = await fetch(`/api/map/identify?${params.toString()}`, {
    headers: { Accept: 'application/json' }
  })

  const bodyText = await response.text()
  if (!response.ok) {
    let message = `Failed to identify map location (${response.status})`
    try {
      const errorJson = JSON.parse(bodyText) as { message?: string; error?: string }
      message = errorJson.message || errorJson.error || message
    } catch {
      // keep default message
    }
    throw new Error(message)
  }

  return JSON.parse(bodyText) as MapIdentifyLocation
}
